// extracted by mini-css-extract-plugin
export default {"root":"style_root__yPoBl","page":"style_page__uLQd+"};